import * as React from 'react';

import Loader from '../_common/loader';
import EntityMark from './entity-mark';
import getTranslatedText from './getTranslatedText';

/* eslint-disable @typescript-eslint/camelcase */
function generateTextParts(text: string, annotations: Annotation[]): AnnotationSpan[] {
    let lastEnd = 0;
    const parts = [];

    const sortedAnnotations = [...annotations].sort((a, b) => a.start_index - b.start_index);

    sortedAnnotations.forEach(annotation => {
        const { start_index, end_index } = annotation;
        if (lastEnd < start_index) {
            parts.push({ content: text.slice(lastEnd, start_index) });
        }
        parts.push({ content: text.slice(start_index, end_index), annotation });
        lastEnd = end_index;
    });

    if (lastEnd < text.length) {
        parts.push({ content: text.slice(lastEnd) });
    }

    return parts;
}
/* eslint-enable @typescript-eslint/camelcase */

export default function NerdMentions(props: NerdMentionsProps): JSX.Element {
    const { results, text, hoveredEntity, onHover } = props;

    if (results.status === 'error') return <p>{results.error}</p>;
    if (results.status === 'pending') return <Loader minHeight="150px" />;

    const { annotations, knowledge_base: knowledgeBase } = results.data.results;

    const textParts = generateTextParts(text, annotations);
    return (
        <>
            {textParts.map((part, idx) => {
                return part.annotation ? (
                    <EntityMark
                        // eslint-disable-next-line react/no-array-index-key
                        key={`${part.content}_${idx}`}
                        knowledgeBase={knowledgeBase}
                        annotation={part.annotation}
                        color={results.data.colorMap[part.annotation.entity_kb_id]}
                        hoveredEntity={hoveredEntity}
                        onHover={onHover}
                        popoverMetadata={[
                            { title: knowledgeBase === 'capiq' ? 'Capital IQ ID:' : 'Wikimedia ID:', value: part.annotation.entity_kb_id },
                            { title: getTranslatedText('entityType'), value: part.annotation.entity_type },
                            { title: getTranslatedText('startIndex'), value: part.annotation.start_index.toString() },
                            { title: getTranslatedText('endIndex'), value: part.annotation.end_index.toString() }
                        ]}
                    >
                        {part.content}
                    </EntityMark>
                ) : (
                    // eslint-disable-next-line react/no-array-index-key
                    <span key={`${part.content}_${idx}`}>{part.content}</span>
                );
            })}
        </>
    );
}
